import { compose } from 'redux'

import { withAuth } from './withAuth'
import { withCookies } from './withCookies'
import { withHelmet } from './withHelmet'
import { withLoader } from './withLoader'
import { withModals } from './withModals'
import { withRedux } from './withRedux'
import { withRouter } from './withRouter'
import { withSystem } from './withSystem'

export const withHocs = compose(
  withRedux,
  withCookies,
  withRouter,
  withHelmet,
  withLoader,
  withAuth,
  withModals,
  withSystem
)
